import React from 'react';
import { UserProfile } from '../../types/advanced-retirement';
import FormattedInput from '../FormattedInput';

interface SpouseInformationSectionProps {
  userProfile: UserProfile;
  handleInputChange: (field: keyof UserProfile, value: any) => void;
}

const SpouseInformationSection: React.FC<SpouseInformationSectionProps> = ({
  userProfile,
  handleInputChange
}) => {
  return (
    <div className="form-section">
      <h3>Spouse Information</h3>
      <div className="form-grid">
        <div className="form-group">
          <label>Spouse Age</label>
          <FormattedInput
            defaultText="43"
            value={userProfile.spouseAge}
            onChange={(value) => handleInputChange('spouseAge', value)}
            min={18}
            max={80}
            step={1}
            formatOptions={{ type: 'number', decimalPlaces: 0 }}
          />
        </div>

        <div className="form-group">
          <label>Spouse Gender</label>
          <select 
            value={userProfile.spouseGender || 'Female'}
            onChange={(e) => handleInputChange('spouseGender', e.target.value)}
          >
            <option value="Male">Male</option>
            <option value="Female">Female</option>
          </select>
        </div>

        <div className="form-group">
          <label>Spouse Retirement Age</label>
          <FormattedInput
            defaultText="65"
            value={userProfile.spouseRetirementAge}
            onChange={(value) => handleInputChange('spouseRetirementAge', value)}
            min={userProfile.spouseAge || 18}
            max={85}
            step={1}
            formatOptions={{ type: 'number', decimalPlaces: 0 }}
          />
        </div>

        <div className="form-group">
          <label>Spouse Life Expectancy Scenario</label>
          <select 
            value={userProfile.spouseLifeExpectancyScenario || 'General'}
            onChange={(e) => handleInputChange('spouseLifeExpectancyScenario', e.target.value)}
          >
            <option value="General">General</option>
            <option value="Conservative">Conservative</option>
            <option value="Optimistic">Optimistic</option>
          </select>
        </div>
      </div>
    </div>
  );
};

export default SpouseInformationSection; 